import React from 'react';

import { Flex, Paper, PaperProps, Stack, Text } from '@mantine/core';

interface DroxyCompactCardProps extends PaperProps {
  title: string;
  description: string;
  icon: React.ReactNode;
}

export function DroxyCompactCard({ title, description, icon, ...paperProps }: DroxyCompactCardProps) {
  return (
    <Paper
      p={16}
      sx={(theme) => ({
        borderRadius: theme.radius.md,
        backgroundColor: 'white',
        border: `1px solid ${theme.colors.gray[2]}`,
        height: 80,
        display: 'flex'
      })}
      {...paperProps}>
      <Flex align="start" gap={12} sx={{ width: '100%' }}>
        <Flex
          align="center"
          justify="center"
          sx={(theme) => ({
            width: 32,
            height: 32,
            borderRadius: '50%',
            backgroundColor: theme.colors.gray[1],
            flexShrink: 0
          })}>
          {icon}
        </Flex>

        <Stack spacing={4} sx={{ flex: 1, overflow: 'hidden' }}>
          <Text size="sm" weight={600} lineClamp={1}>
            {title}
          </Text>
          <Text size="xs" color="dimmed" lineClamp={2}>
            {description}
          </Text>
        </Stack>
      </Flex>
    </Paper>
  );
}
